var _excluded = ["className", "href", "tag"],
  _excluded2 = ["children", "classes", "title", "titleId", "primaryCta", "secondaryCta", "cancelProps", "footer", "fullScreenMobile", "enableContentScroll"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import Modal from '../modal';
import Button from '../button';
require("./dialog-modal.css");
var styles = {
  "modal": "modal-1HN_J",
  "enableContentScroll": "enableContentScroll-1YX2I",
  "fullScreenMobile": "fullScreenMobile-1qwLd",
  "title": "title-2cXAU",
  "scrollableModalContainer": "scrollableModalContainer-lPA4n",
  "scrollableModalContent": "scrollableModalContent-arNn3",
  "content": "content-1jTDu",
  "primaryCta": "primaryCta-1bRYX",
  "secondaryCtaBlock": "secondaryCtaBlock-Y8e2s",
  "secondaryCta": "secondaryCta-25wwC",
  "footer": "footer-3eOb7"
};
var SecondaryCta = _ref => {
  var {
      className,
      href,
      tag
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'button';
  if (!tag && href) {
    Tag = 'a';
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cs(className, styles.secondaryCta, 'lll-link-primary'),
    href: href
  }, otherProps));
};
SecondaryCta.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
SecondaryCta.defaultProps = {
  className: undefined,
  href: undefined,
  tag: undefined
};
var ScrollableWrapper = _ref2 => {
  var {
    enabled,
    children
  } = _ref2;
  var wrappedChildren = /*#__PURE__*/React.createElement("div", {
    className: styles.scrollableModalContent
  }, children);
  return enabled ? wrappedChildren : children;
};
ScrollableWrapper.propTypes = {
  enabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
var DialogModal = _ref3 => {
  var {
      children,
      classes,
      title,
      titleId,
      primaryCta,
      secondaryCta,
      cancelProps,
      footer,
      fullScreenMobile,
      enableContentScroll
    } = _ref3,
    otherProps = _objectWithoutProperties(_ref3, _excluded2);
  var primaryCtaRef = useRef();
  return /*#__PURE__*/React.createElement(Modal, _extends({
    "aria-labelledby": titleId,
    classes: {
      modal: cs(classes.modal, styles.modal, {
        [styles.fullScreenMobile]: fullScreenMobile,
        [styles.enableContentScroll]: enableContentScroll
      }),
      backdrop: classes.backdrop,
      container: classes.container,
      modalContent: cs(classes.modalContent, {
        [styles.scrollableModalContainer]: enableContentScroll
      })
    },
    openFocusRef: primaryCta ? primaryCtaRef : null,
    cancelProps: cancelProps,
    fullScreenMobile: fullScreenMobile
  }, otherProps), /*#__PURE__*/React.createElement(ScrollableWrapper, {
    enabled: enableContentScroll
  }, /*#__PURE__*/React.createElement("h1", {
    id: titleId,
    className: cs(styles.title, classes.heading, 'lll-text-left')
  }, title), children && /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children)), primaryCta && /*#__PURE__*/React.createElement(Button, _extends({
    className: styles.primaryCta,
    kind: "primary",
    block: true,
    ref: primaryCtaRef
  }, primaryCta)), secondaryCta && /*#__PURE__*/React.createElement("div", {
    className: styles.secondaryCtaBlock
  }, /*#__PURE__*/React.createElement(SecondaryCta, secondaryCta)), footer && /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, footer));
};
DialogModal.propTypes = {
  children: PropTypes.node,
  /** CSS classNames applied to modal elements */
  classes: PropTypes.shape({
    modal: PropTypes.string,
    modalContent: PropTypes.string,
    backdrop: PropTypes.string,
    container: PropTypes.string,
    heading: PropTypes.string
  }),
  title: PropTypes.node.isRequired,
  /** ID for title element. Used to provide aria-labelledby property
   * on modal to give screen readers context for the modal's purpose.
   */
  titleId: PropTypes.string.isRequired,
  /** Props for primary CTA. Matches props of `Button` component. */
  // eslint-disable-next-line react/forbid-prop-types
  primaryCta: PropTypes.object,
  /** Props for secondary CTA. */
  secondaryCta: PropTypes.shape({
    className: PropTypes.string,
    href: PropTypes.string,
    /** HTML tag for CTA. Defaults to `button`, or `a` if `href` prop is present */
    tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  }),
  // eslint-disable-next-line react/forbid-prop-types
  cancelProps: PropTypes.object,
  footer: PropTypes.node,
  /* See `Modal` component */
  fullScreenMobile: PropTypes.bool,
  /** Enable this will allow for scrollable content in the modal for desktop and mobile */
  enableContentScroll: PropTypes.bool
};
DialogModal.defaultProps = {
  children: undefined,
  classes: {},
  primaryCta: undefined,
  secondaryCta: undefined,
  cancelProps: null,
  footer: undefined,
  fullScreenMobile: false,
  enableContentScroll: false
};
export default DialogModal;